import React, {ReactNode} from 'react';
import joinClassNames from '../../../functions/joinClassNames';

export const defaultClassNameWithoutMargin = 'px-1 d-flex flex-column justify-content-center';
export const defaultClassName = 'mb-2 mb-xl-0 ' + defaultClassNameWithoutMargin;

export default function NavbarColumn(props: {children: ReactNode}) {
  return <div className={joinClassNames('col-3 col-md-2 col-xl-1', defaultClassName)}>{props.children}</div>;
}
